<template>
  <div class="right-sidebar">
    <hot-table-edit-feature></hot-table-edit-feature>
    <edit-feature></edit-feature>
    <tools></tools>
    <feature-details-popup></feature-details-popup>
  </div>
</template>
<script>
import Tools from "./components/tools.component";
import EditFeature from "./components/edit-feature.component";
import HotTableEditFeature from "./components/hot-table-edit-features";
import FeatureDetailsPopup from "./../feature-details-popup.component";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    Tools,
    EditFeature,
    HotTableEditFeature,
    FeatureDetailsPopup
  }
};
</script>
<style lang="scss">
.right-sidebar {
  position: absolute;
  z-index: 1000;
  right: 3rem;
  top: 1rem;

  .control-btns {
    .button {
      margin: 0 5px;
    }
  }
  .c-table {
    .key {
      width: 20%;
      background: #ccc;
    }
  }
  .is-box {
    z-index: 100;
    position: relative;
    background: white;
    padding-top: 0.75rem;
    position: fixed;
    width: 280px;
    top: 0;
    right: 0;
    bottom: 0;
    &--tool {
      .tab-content {
        padding: 0;
      }
    }
    .close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      border-radius: 30px;
      z-index: 4;
    }
    .input,
    .select select {
      // border-radius: 5px;
      border-color: #dddddd;
    }
    .select,
    .select select {
      width: 100%;
    }
    .select select,
    input {
      border: 0;
      border-bottom: 1px solid;
      border-radius: 0;
      border-color: #dddddd;
      box-shadow: none;
    }
    .cancel-btn {
      border: none;
      box-shadow: none;
    }
  }
  .vue-treeselect__control{
    border:0
  }
}
</style>

